import { Component, Input, Output, EventEmitter, OnInit, OnChanges } from '@angular/core';

@Component({
    selector: 'hmt-custom-pagination',
    templateUrl: './custom-pagination.component.html',
    styleUrls: ['./custom-pagination.component.scss'],
    standalone: false
})
export class CustomPaginationComponent implements OnInit, OnChanges {
  @Input() totalItems = 0;
  @Input() pageSize = 10;
  @Input() pageIndex = 0;
  @Input() loading = false;
  @Input() showInfo = true;
  @Input() showNoDataMessage = true;
  @Input() noDataMessage = 'No data available for the selected criteria';
  @Input() showPageSizeSelector = false;
  @Input() pageSizeOptions: number[] = [10, 15, 20];

  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  totalPages = 0;
  mathRef = Math;

  ngOnInit(): void {
    this.calculateTotalPages();
  }

  ngOnChanges(): void {
    this.calculateTotalPages();
  }

  private calculateTotalPages(): void {
    this.totalPages = this.totalItems > 0 ? Math.ceil(this.totalItems / this.pageSize) : 0;
  }

  onPageSizeChange(size: number): void {
    this.pageSizeChange.emit(size);
  }

  changePage(page: number): void {
    if (page >= 0 && page < this.totalPages && this.pageIndex !== page) {
      this.pageChange.emit(page);
    }
  }

  getPageNumbers(): number[] {
    const pages: number[] = [];

    if (this.totalPages <= 0) {
      return [];
    }

    if (this.totalPages <= 5) {
      for (let i = 0; i < this.totalPages; i++) {
        pages.push(i);
      }
      return pages;
    }

    pages.push(0);

    const startPage = Math.max(1, this.pageIndex - 1);
    const endPage = Math.min(this.totalPages - 2, this.pageIndex + 1);

    if (startPage > 1) {
      pages.push(-1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (endPage < this.totalPages - 2) {
      pages.push(-2);
    }

    pages.push(this.totalPages - 1);

    return pages;
  }

  trackByKey(index: number, item: number): number {
    return item;
  }
} 